const WHITESPACE_PATTERN = /\s+/;

const splitClassTokens = (classString = '') =>
  classString.split(WHITESPACE_PATTERN).filter(Boolean);

export default splitClassTokens;
